import { configureStore } from '@reduxjs/toolkit';
import { api } from './api';
import alertsReducer from '../features/alerts/alertsSlice';
import detectionReducer from '../features/detection/detectionSlice';
import rulesUiReducer from '../features/rules/rulesUiSlice';
import projectsReducer from '../features/projects/projectsSlice';
import mapUiReducer from '../features/map/mapUiSlice';
import investigationReducer from '../features/map/investigationSlice';

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    alerts: alertsReducer,
    detection: detectionReducer,
    rulesUi: rulesUiReducer,
    projects: projectsReducer,
    mapUi: mapUiReducer,
    investigation: investigationReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
